/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';

import './inc/theme/menu';
import './inc/theme/submenu';
import './inc/theme/submenu-open';
import './inc/theme/flyout-menu-toggle';
import './inc/theme/search-modal';
import './inc/theme/top-bar-close';
import stickyHeader from './inc/theme/sticky-header';
import './inc/theme/anchor-nav';

stickyHeader.init();
